import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderWrapper from "../Header/HeaderWrapper";
import FooterWrapper from "../Footer/FooterWrapper";
import { Link } from "react-router-dom";
import SecondMeetDoctors from "../SecondMeetDoctors";
import { SendPostRequest } from "../../http";
import { capitalize } from "@mui/material";
import TextMainBannerWrapper from "../TextMainBanners/TextMainBannerWrapper";
import HomeReviewsWrapper from "../Reviews/HomeReviewsWrapper";
import CeoMessageWrapper from "../CeoMessage/CeoMessageWrapper";
import WrapperVisionMissionValue from "../HospitalWhoWeAre/WrapperVisionMissionValue";
import HospitalWhoWeAreWrapper from "../HospitalWhoWeAre/HospitalWhoWeAreWrapper";

function AboutUs() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [hostpitalAbout, setHostpitalAbout] = useState({});

  const owlOptions = {
    loop: true,
    nav: false,
    dots: false,
    autoplay: true,
    autoplayTimeout: 2500,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    margin: 30,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      1000: { items: 3 },
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    getHostpitalAboutData();
  }, []);

  const getHostpitalAboutData = async () => {
    const response = await SendPostRequest("content/aboutus");
    setHostpitalAbout(response?.data);
  };
    const [homeIntroData, setHomeIntroData] = useState({});

  useEffect(() => {
    getHomeIntroData();
  }, []);

  const getHomeIntroData = async () => {
    const response = await SendPostRequest("content/home");
    setHomeIntroData(response?.data);
  };


  const Intro_principles = [
    "Vision:",
    "Mission:",
    "Values:",
  ]

  return (
    <div className="page-wrapper-inner">
      <div className="page-wrapper-inner">
        <HeaderWrapper />

        <TextMainBannerWrapper Heading="About Us" Image="theme-2-banner-aboutus.webp" />

        <HospitalWhoWeAreWrapper hostpitalAbout={hostpitalAbout}/>
         <WrapperVisionMissionValue
              principles={homeIntroData?.principles}
              siteType={sitedata?.site_type}
            />



        {/* {hostpitalAbout?.who_we_are_description && hostpitalAbout?.who_we_are_video && (
          <div className="py-4">
            <div className="container">
              <div className="row pt-5">
                <div className="col-lg-6 col-md-8 col-12">
                  <div className="title-wrap margin-bottom-30">
                    <div className="section-title margin-bottom-25">
                      <h2 className="section-title mb-0 text-uppercase">
                        {hostpitalAbout?.who_we_are_heading}
                      </h2>
                      <span className="section-border-bottom"></span>
                    </div>
                    <div className="pad-top-15">
                      <p
                        className="margin-bottom-20 text-justify"
                        dangerouslySetInnerHTML={{
                          __html: hostpitalAbout?.who_we_are_description,
                        }}
                      ></p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-4 col-12">
                  <div
                    className="about-vedio-frame"
                    dangerouslySetInnerHTML={{
                      __html: hostpitalAbout?.who_we_are_video?.replace(
                        /src="([^"]+)"/,
                        (match, p1) => {
                          const newUrl = new URL(p1);
                          newUrl.searchParams.set("autoplay", "1");
                          newUrl.searchParams.set("rel", "0");
                              newUrl.searchParams.set("mute", "1"); // ✅ Mute video
                          return `src="${newUrl.toString()}"`;
                        }
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )} */}

        {/* <div
          id="flip-box-section"
          className="flip-box-section pad-bottom-md-none index-1 relative semi-dark mt-4 mb-5 "
        >
          <div className="container">
            <div className="row special-feature">
              <div className="offset-md-2 col-md-8">
                <div className="title-wrap text-center">
                  <div className="section-title margin-bottom-40">
                    <h2 className="title text-uppercase mb-0">
                      {hostpitalAbout?.about_short_heading || ""}
                      <span className="theme-color"></span>
                    </h2>
                    <span className="section-border-bottom center"></span>
                  </div>

                </div>
              </div>
              <div className="col-12">
                <div className="section-description hospital-about text-center mb-5" style={{ maxWidth: "100%" }}>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: hostpitalAbout?.about_short_description || "",
                    }}
                  ></p>
                </div>
              </div>

              {hostpitalAbout?.principles?.map((data, index) => (
                <div
                  className="col-lg-4 col-md-6 col-12 mb-3"
                  key={index}
                  data-animation="fadeInDown"
                >
                  <div className="s-feature-box text-center s-feature-box-mobile ">
                    <div className="mask-top">
                      <img
                        src={data?.image || "/assets/img/no-image.png"}
                        className=""
                        alt=""
                        style={{ width: "50px", height: "50px" }}
                      />
                      <h4>{data?.heading || Intro_principles[index]}</h4>
                    </div>
                    <div className="mask-bottom">
                      <img
                        src={data?.image || "/assets/img/no-image.png"}
                        className=""
                        alt=""
                        style={{ width: "50px", height: "50px" }}
                      />
                      <h4 className="mb-2">{data?.heading || Intro_principles[index]}</h4>
                      <p
                        dangerouslySetInnerHTML={{ __html: data?.description || "No Description Found" }}
                      ></p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div> */}
        <CeoMessageWrapper />

        <SecondMeetDoctors />
        <section
          id="get-quote-section"
          className="get-quote-section bg-theme pad-top-40 pad-bottom-50 relative index-1 mb-5"
        >
          <div className="container">
            <div className="row get-quote-3">
              <div className="col-lg-12">
                <div className="title-wrap mb-0">
                  <div className="section-title text-center mb-3">
                    <h3 className="title text-uppercase home-discount-offer">
                      {sitedata?.advertisement?.short_detail_for_button ||
                        "50% off !! Come With OurOffer Coupons And Refer Friends!!"}
                    </h3>
                  </div>
                </div>
                <div className="button justify-content-center d-flex">
                  <Link
                    to={sitedata?.advertisement?.button_url || "#"}
                    className="btn btn-border ms-3"
                    target="_blank"
                    rel="noopener noreferrer"

                  >
                    {sitedata?.advertisement?.button_name || "Book Now"}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* {sitedata?.permissions?.review !== "hide" && <HomeReviewsWrapper />} */}
        <HomeReviewsWrapper />

        <FooterWrapper />
      </div>
    </div>
  );
}

export default AboutUs;
